import api from './api';

export const sendMessage = (messageData) =>
  api.post('/api/messages/v2/sendmessage', messageData)
    .then(r => r.data)
    .catch(error => {
      console.error('Send message error:', error);
      throw error;
    });

export const updateMessage = (messageData) =>
  api.post('/api/messages/updatemessage', messageData)
    .then(r => r.data)
    .catch(error => {
      console.error('Update message error:', error);
      throw error;
    });

export const getConversation = (queryParams) => {
  const { receiverShortId, receiverId, requasterShortId, page = 1, pageSize = 100000 } = queryParams;

  if (!receiverShortId || !receiverId) {
    return Promise.reject(new Error('Missing required parameters: receiverShortId and receiverId'));
  }

  const params = new URLSearchParams({
    receiverShortId,
    receiverId,
    requesterShortId: requasterShortId || 'Admin',
    page,
    limit: pageSize,
  });

  return api.get(`/api/messages/v2/getconversation?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get conversation error:', error);
      throw error;
    });
};

export const setMessageStatus = (conversationData) =>
  api.post('/api/messages/setmessagestatus', conversationData)
    .then(r => r.data)
    .catch(error => {
      console.error('Set message status error:', error);
      throw error;
    });

export const getMessagesAdmin = (conversationData) =>
  api.post('/api/messages/getmessagesadmin', conversationData)
    .then(r => r.data)
    .catch(error => {
      console.error('Get messages admin error:', error);
      throw error;
    });

export const getMessages = (params) =>
  api.post('/api/messages/getmessages', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get messages error:', error);
      throw error;
    });

export const getConversations = (params) =>
  api.post('/api/messages/getconversations', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get conversations error:', error);
      throw error;
    });

export const conversations = (queryParams) => {
  const { messageType, search, page, limit } = queryParams;
  const url = `/api/admin/v2/conversations?messageType=${messageType}${search ? `&search=${search}` : ""}&page=${page}&limit=${limit}`;
  return api.get(url)
    .then(r => r.data)
    .catch(error => {
      console.error('Conversations error:', error);
      throw error;
    });
};

export const unsuspenduser = (payload) =>
  api.post('/api/admin/unsuspendUser', payload)
    .then(r => r.data)
    .catch(error => {
      console.error('Unsuspend user error:', error);
      throw error;
    });

export const bulkread = (messageData) =>
  api.patch('/api/admin/bulkRead', messageData)
    .then(r => r.data)
    .catch(error => {
      console.error('Bulk read error:', error);
      throw error;
    });

export const getMessagesFilterCounts = (queryParams) => {
  const params = new URLSearchParams(queryParams).toString();
  const url = `/api/admin/conversationsCount?${params}`;
  return api.get(url)
    .then(r => r.data)
    .catch(error => {
      console.error('Get messages filter counts error:', error);
      throw error;
    });
};

export const countMessages = (conversationData) =>
  api.post('/api/messages/countmessages', conversationData)
    .then(r => r.data)
    .catch(error => {
      console.error('Count messages error:', error);
      throw error;
    });
